import React, { ReactNode } from "react";

interface SettingsRowProps {
  label: string;
  children: ReactNode;
  fullWidth?: boolean;
  labelAbove?: boolean;
}

const SettingsRow: React.FC<SettingsRowProps> = ({ label, children, fullWidth, labelAbove }) => {
  if (labelAbove) {
    return (
      <div className="settings-page__config-item settings-page__config-item--stacked">
        <div className="settings-page__row-label">{label}</div>
        <div className={`settings-page__config-value${fullWidth ? ' settings-page__config-value--full' : ''}`}>{children}</div>
      </div>
    );
  }

  return (
    <div className="settings-page__config-item">
      <span className="settings-page__config-label">{label}</span>
      <div className={`settings-page__config-value${fullWidth ? ' settings-page__config-value--full' : ''}`}>{children}</div>
    </div>
  );
};

export default SettingsRow;


